<script lang="ts" setup>
const { template } = storeToRefs(useTemplateStore());

const contentItems = computed(() => {
  const general = template.value.general;
  const { groom, bride } = general.parents;

  return [
    {
      name: general.groom_name,
      parentNames: `Putra ${groom.order} dari ${groom.father} & ${groom.mother}`,
    },
    {
      name: general.bride_name,
      parentNames: `Putri ${bride.order} dari ${bride.father} & ${bride.mother}`,
    },
  ];
});
</script>

<template>
  <div class="flex flex-col gap-4 text-center justify-center xs:pt-20 md:gap-8 lg:gap-12">
    <header
      class="flex flex-col items-center justify-center gap-1 text-center"
    >
      <NuxtImg
        data-aos="zoom-in-up"
        data-aos-offset="60"
        src="/events-hero-flower.webp"
        alt="Flower Decoration"
        class="w-auto h-[110px] object-contain md:w-[181px] md:h-auto"
        loading="lazy"
        decoding="async"
      />

      <p
        data-aos="fade-up"
        data-aos-delay="200"
        data-aos-duration="600"
        class="leading-[150%] text-primary-600 max-w-xs text-sm xs:text-base sm:max-w-[353px] md:text-base md:max-w-sm lg:text-xl lg:max-w-md xl:text-2xl xl:max-w-lg"
      >
        Dengan rahmat Tuhan Yang Maha Esa, kami mengundang Anda untuk menghadiri pernikahan putra-putri kami
      </p>
    </header>

    <article
      class="flex flex-col py-6 gap-6 md:gap-10 lg:gap-12"
    >
      <template
        v-for="(item, index) in contentItems"
        :key="item.name"
      >
        <div
          class="flex flex-col gap-4 text-primary-800"
        >
          <h2
            class="font-cursive text-4xl xs:text-5xl md:text-6xl lg:text-7xl font-medium"
            data-aos="fade-up"
            :data-aos-delay="300 + index * 200"
          >
            {{ item.name }}
          </h2>

          <p
            class="text-sm xs:text-base md:text-lg lg:text-xl"
            data-aos="fade"
            data-aos-duration="800"
            :data-aos-delay="400 + index * 200"
          >
            {{ item.parentNames }}
          </p>
        </div>

        <span
          v-if="index === 0"
          class="text-5xl font-cursive"
          aria-hidden="true"
          data-aos="zoom-in"
          data-aos-delay="500"
        >
          &
        </span>
      </template>
    </article>

    <footer
      class="flex items-center justify-center"
      data-aos="fade"
      data-aos-delay="400"
    >
      <p
        class="max-w-3xs text-primary-600 text-sm xs:text-base xs:max-w-xs sm:text-base md:max-w-sm md:text-lg lg:text-xl lg:max-w-md"
      >
        Kami berharap dapat merayakan momen bahagia ini bersama Anda
      </p>
    </footer>
  </div>
</template>
